import React from "react";
import { Link } from "react-router-dom";
import h1corner from "../img/h1corner.png";
import { areaLink, adminAreaLink } from "../utils/climbingAreaUtils";
import { ClimbingArea } from "../types"

export interface ClimbingAreaLinkProps {
    area: ClimbingArea,
    onClick?: React.MouseEventHandler<HTMLAnchorElement>,
    onMouseDown?: React.MouseEventHandler<HTMLAnchorElement>
}
export function ClimbingAreaLink(props: ClimbingAreaLinkProps) {
    let area = props.area;
    return (
        <Link to={areaLink(area)} key={area.areaId} onClick={props.onClick} onMouseDown={props.onMouseDown}>{area.name}</Link>
    );
}

export interface ClimbingAreaLinkStaticProps { area: ClimbingArea }
export function ClimbingAreaLinkStatic(props: ClimbingAreaLinkStaticProps) {
    let area = props.area;
    return (
        <a href={areaLink(area)}>{area.name}</a>
    );
}

export interface AdminAreaLinkProps { 
    code: string,
    className?: string,
    children: React.ReactNode
}
export function AdminAreaLink(props: AdminAreaLinkProps) {
    let { code, className, children } = props;
    return (
        <Link to={adminAreaLink(code)} key={code} className={className}>{children}</Link>
    );
}

export interface AdminAreaLinkStaticProps { area: ClimbingArea }
export function AdminAreaLinkStatic(props: AdminAreaLinkStaticProps) {
    let area = props.area;
    return <AdminAreaLink code={area.adminArea}>{area.adminAreaName}</AdminAreaLink>
}

export interface TopHeadingProps { children: React.ReactNode }
export function TopHeading(props: TopHeadingProps) {
    return (
        <React.Fragment>
          <h1 className="top">{props.children}</h1>
          <div className="h1corner"><img src={h1corner} width="17" height="13" alt=""/></div>
         </React.Fragment>

    )
}


export interface ContentHeadingProps { children: React.ReactNode }
export function ContentHeading(props: ContentHeadingProps) {
    return (
        <React.Fragment>
            <h1>{props.children}</h1>
            <div className="h1corner"><img src={h1corner} width="17" height="13" alt=""/></div>
        </React.Fragment>
    )
    //return <h1>{props.children}</h1>
}